<!--
    Styles
-->

<style scoped>


    /* main */

    .deal {
        border: 1px solid var(--cl-gray);
        border-left: 3px solid;
        border-radius: 3px;
    }


    /* info */

    .deal .info {
        padding: 0.3em 0.6em;
        min-width: 0;
    }
    .deal .info .w7 {
        margin-right: 0.3em;
        font-size: 120%;
    }


    /* button */

    .deal .button {
        flex-shrink: 0;
        visibility: hidden;
        text-align: center;
        padding: 0 0.5em;
        border-left: 1px solid var(--cl-orange);
        color: var(--cl-orange);
    }
    .deal .button:hover {
        background: rgba(243,152,0,0.1);
    }
    .deal .button .success,
    .deal .button .danger {
        visibility: hidden;
        height: 0;
    }


    /* hover state */

    .deal:not(.selected):hover {
        border-color: var(--cl-orange);
        background: var(--cl-orange-light);
    }
    .deal:hover .button {
        visibility: visible;
    }


    /* selected state */

    .deal.selected .button {
        visibility: visible;
        background: var(--cl-blue);
        color: var(--cl-white);
        border-left-color: transparent;
    }
    .deal.selected .button .default {
        visibility: hidden;
        height: 0;
    }
    .deal.selected .button .success {
        visibility: visible;
        height: auto;
    }
    .deal.selected .button:hover {
        background: var(--cl-red);
    }
    .deal.selected .button:hover .success {
        visibility: hidden;
        height: 0;
    }
    .deal.selected .button:hover .danger {
        visibility: visible;
        height: auto;
    }


</style>



<!--
    Template
-->

<template>
    <div class="deal u-row u-stretch" :style="{borderLeftColor: priceColor(deal.dealPrice)}" @mouseenter="hover({deal: deal.id})" @mouseleave="hover({deal: null})" :class="{selected: isSelected(deal.id)}">

        <div class="info u-flex u-col">
            <p>
                <span class="w7">{{ deal.dealPrice | price }}円</span>
                <span v-if="sqm">坪単価：{{ deal.dealPrice / sqm * tsubo | price }}円</span>
            </p>
            <p>
                <span v-if="sqm">{{ sqm }}m²,</span>
                <span v-if="deal.floor">{{ deal.floor }}F,</span>
                <span v-if="deal.floorPlan">{{ deal.floorPlan }},</span>
                <span v-if="deal.done">{{ deal.dealtAt | date }} 成約</span>
                <span v-else>{{ deal.openedAt | date }} 募集</span>
            </p>
        </div>

        <a class="button w7 u-col" @click="$emit('select', deal)">
            <span class="default">レポートに</span>
            <span class="default">追加する</span>
            <span class="success">追加済み</span>
            <span class="danger">削除する</span>
        </a>

    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapGetters, mapActions} from 'vuex'
    import {date, price} from '@/common/helpers/parse'


    export default {

        filters: {
            date,
            price
        },

        props: [
            'deal'
        ],

        computed: {

            ...mapGetters('search', [
                'isSelected'
            ]),

            ...mapGetters('dashboard', [
                'priceColor'
            ]),

            sqm () {
                return this.deal.sqm ?? this.deal.totalFloorSqm;
            }

        },

        methods: {

            ...mapActions('search', [
                'select'
            ]),

            ...mapActions('dashboard', [
                'hover'
            ])

        }

    }

</script>

